import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { CompanyConfigurationService } from '../../../../core/services/company-configuration-service';
import { toSignal } from '@angular/core/rxjs-interop';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CompanyUnit } from '../../../../core/api/mhsConfigurationApiClient';
import { NfzBranchLookup } from '../../../../core/context/nhf-branch-lookup';
@Component({
  selector: 'app-company-structure-view',
  imports: [CommonModule, NzCardModule, NzTagModule, NzIconModule],
  templateUrl: './company-structure-view.html',
  styleUrl: './company-structure-view.scss',
})
export class CompanyStructureViewComponent {
  companyConfigurationService = inject(CompanyConfigurationService);

  companyConfiguration = toSignal(this.companyConfigurationService.getCompanyConfiguration(), {
    initialValue: null,
  });

  structure = computed(() => this.companyConfiguration()?.structure ?? null);
  units = computed(() => this.structure()?.units ?? []);

  formatAddress(
    city?: string,
    street?: string,
    houseNo?: string,
    flatNo?: string,
    zip?: string,
  ): string {
    const streetPart = [street, houseNo].filter(Boolean).join(' ');
    const flatPart = flatNo ? `/${flatNo}` : '';
    const locationPart = [zip, city].filter(Boolean).join(' ');
    const left = streetPart ? `${streetPart}${flatPart}` : '';

    return [left, locationPart].filter(Boolean).join(', ') || 'Brak adresu';
  }

  unitAddress(unit: CompanyUnit): string {
    return this.formatAddress(unit.city, unit.street, unit.houseNo, unit.flatNo, unit.zip);
  }

  divisionPreview(unit: CompanyUnit, takeCount = 3): string[] {
    return (unit.divisions ?? [])
      .map((division) => division.name?.trim())
      .filter((name): name is string => Boolean(name))
      .slice(0, takeCount);
  }

  divisionRemainingCount(unit: CompanyUnit, takeCount = 3): number {
    const all = (unit.divisions ?? []).filter((division) => Boolean(division.name?.trim())).length;
    return Math.max(all - takeCount, 0);
  }
  getNhfBranchName(unit: CompanyUnit): string {
    const nhfBranchCode = unit.nhfBranchCode;
    if (!nhfBranchCode) {
      return 'Brak przypisanego oddziału NFZ';
    }
    const branch = NfzBranchLookup.branches.find((b) => b.code === nhfBranchCode);
    return branch?.name ?? `Nieznany oddział NFZ (${nhfBranchCode})`;
  }
}
